import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import cut1 from "../../assets/img/diamond_Cut_1.webp";
import cut2 from "../../assets/img/cut_2.jpg";
import cut3 from "../../assets/img/cut_3.webp";
import Clarity1 from "../../assets/img/Clarity1.jpg";
import color1 from "../../assets/img/color1.png";
import Carat2 from "../../assets/img/Carat2.jpg";
import Carat3 from "../../assets/img/Carat3.jpg";
const EducationSummary = () => {
  return (
    <>
      <section className="section-spacing-x section-spacing-y">
        <Container fluid>
          <h1 className="heading mb-3 text-center"> 4 C's of Diamonds</h1>
          <p className="para-content mb-3 text-lg-center education-para">
            Diamonds are not just stunning to look at; they are also incredibly
            unique due to a combination of factors that influence their quality,
            appearance, and ultimately, their value. The 4 C's of diamonds
            provide a standard for evaluating each diamond's characteristics and
            help buyers make informed decisions. Understanding the 4 C's will
            ensure that you select a diamond that meets both your aesthetic and
            budgetary needs.
          </p>
          <h2 className="heading text-center">Cut</h2>
          <p className="para-content mb-3">
            How well the diamond has been shaped and faceted. A well-cut diamond
            will have better brilliance and sparkle.
          </p>
          <Row className="mb-lg-5">
            <Col lg={4}>
              <div className="dimond-cut-img">
                <img src={cut1} className="img-fluid" alt="dimond cut" />
              </div>
            </Col>
            <Col lg={5}>
              <div className="dimond-cut-img">
                <img src={cut2} className="img-fluid" alt="dimond cut" />
              </div>
            </Col>
            <Col lg={3}>
              <div className="dimond-cut-img">
                <img src={cut3} className="img-fluid" alt="dimond cut" />
              </div>
            </Col>
          </Row>
          <h2 className="heading text-center">Clarity</h2>
          <p className="para-content mb-3">
            Every diamond is unique and often contains tiny internal or external
            imperfections known as inclusions and blemishes. These naturally
            occurring characteristics can affect a diamond’s clarity grade,
            which ranges from Flawless (FL) to Included (I1, I2, I3).{" "}
          </p>
          <Row className="mb-5">
            <Col lg={12}>
              <div className="dimond-cut-img w-100">
                <img src={Clarity1} className="img-fluid" alt="dimond cut" />
              </div>
            </Col>
          </Row>
          <h2 className="heading text-center">Color</h2>
          <p className="para-content mb-3">
            Diamonds are graded on their color, which refers to the presence of
            any color in a diamond, specifically yellow or brown tints. A
            diamond with little to no color is considered more valuable than a
            diamond with noticeable color. The color scale starts from D
            (colorless) to Z (light yellow or brown). The closer a diamond is to
            colorless, the rarer and more valuable it is.
          </p>
          <Row className="mb-5">
            <Col lg={12}>
              <div className="dimond-cut-img">
                <img src={color1} className="img-fluid" alt="dimond cut" />
              </div>
            </Col>
          </Row>
          <h2 className="heading text-center">Carat</h2>
          <p className="para-content mb-3">
            Carat weight measures the size of the diamond, and is often the most
            immediately noticeable aspect. One carat is equal to 0.2 grams.
            However, carat weight alone doesn't tell the whole story of a
            diamond's size, as diamonds of the same carat weight can look
            different depending on their proportions and cut.
          </p>
          <Row className="mb-3">
            <Col lg={6}>
              <div className="dimond-cut-img">
                <img src={Carat2} className="img-fluid" alt="dimond cut" />
              </div>
            </Col>
            <Col lg={6}>
              <div className="dimond-cut-img">
                <img src={Carat3} className="img-fluid" alt="dimond cut" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default EducationSummary;
